import React from 'react';
import PropTypes from 'prop-types';
import { ConnectionOption } from '../EditorOption/';

const getOptionsValue = (options, value) =>
  options.find(opt => opt[0] === value)[1];

const EditorAndroid = ({ onOptionChange, options }) =>
  <ol className="code-container">
    <li className="line-row">
      <span>{'Auth0 account = new Auth0("cid", "domain");'}</span>
    </li>
    <li className="line-row">
      <span>{'Lock lock = Lock.newBuilder(account, new LockCallback() {…})'}</span>
    </li>
    <li className="line-row indent-1">
      <span>{'.allowedConnections(Arrays.asList('}</span>
      <ConnectionOption
        value={getOptionsValue(options, 'allowedConnections')}
        onChange={onOptionChange}
      />
      <span>{'))'}</span>
    </li>
    <li className="line-row indent-1">
      <span>{'.build(this);'}</span>
    </li>
    <li className="line-row">
      <span>{'startActivity(lock.newIntent(this));'}</span>
    </li>
  </ol>;

EditorAndroid.propTypes = {
  onOptionChange: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  logos: PropTypes.array,
  defaultColor: PropTypes.string
};

export default EditorAndroid;



// WEBPACK FOOTER //
// ./src/components/Editor/EditorAndroid.js


// WEBPACK FOOTER //
// webpack:///src/components/Editor/EditorAndroid.js